import React, { useEffect, useState } from 'react'
import API from '../../../../../services/API'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import Autocomplete from '@mui/material/Autocomplete'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import TextField from '@mui/material/TextField'
import SendIcon from '@mui/icons-material/Send'
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'

const PrimaryContact = ({ event, setEvent }) => {
  const [contactOptions, setContactOptions] = useState([])
  const [uploading, setUploading] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState(event?.mainContact?.phone)

  useEffect(() => {
    API.post('/client-portal/contact-options', {
      orgID: event.organisation,
    }).then((res) => {
      if (res.status === 200) {
        setContactOptions(res.data)
      }
    })
  }, [])

  const handleChange = (e, value) => {
    setSelectedContact(value)
    API.post('/client-portal/event/main-contact', {
      eventID: event._id,
      mainContact: value._id,
    })
      .then((res) => {
        if (res.status === 200) {
          setEvent((prev) => ({ ...prev, mainContact: value }))
          setPhoneNumber(value.phone)
        }
      })
      .catch(() => {})
      .finally(() => setUploading(false))
  }

  return (
    <Grid item xs={12} md={6} lg={4}>
      <DetailsBox title="Primary Contact">
        {uploading || (contactOptions.length === 0 && <LinearProgress />)}
        <Autocomplete
          loading={contactOptions.length === 0}
          loadingText="Loading..."
          disableClearable
          value={event?.mainContact ?? null}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField {...params} disabled={uploading} />
          )}
          options={contactOptions}
          getOptionLabel={(option) =>
            `${option?.userAccount?.firstName} ${option?.userAccount?.lastName} (${option?.companyRole})`
          }
          isOptionEqualToValue={(opt, value) => opt._id === value._id}
        />
        <Stack direction="row" gap={1}>
          <TextField
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            label="Phone Number"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <Button
            sx={{ borderRadius: 1 }}
            variant="contained"
            color="success"
            disabled={phoneNumber === event.mainContact?.phone}
          >
            <Tooltip title="Update Phone Number">
              <SendIcon />
            </Tooltip>
          </Button>
        </Stack>
      </DetailsBox>
    </Grid>
  )
}

export default PrimaryContact
